import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_MYSELF } from "../../config/config.json";
import { decryptStorage } from 'utils/utils';
const baseQuery = fetchBaseQuery({
    baseUrl: API_MYSELF,
    extraOptions: { timeout: 30000 },
    prepareHeaders: (headers) => {
        headers.set('content-type', 'application/json')
        headers.set('access-control-allow-origin', '*')
        headers.set('accept', '*/*')
        const token = decryptStorage(localStorage.getItem("token")) 
        if (token) headers.set('Authorization', `Bearer ${token}`)
        return headers
    }
});

export const microserviceApi = createApi({
    reducerPath: 'microserviceApi',
    baseQuery,
    tagTypes: ['Certificate'],
    endpoints: () => ({})
});

export const microServiceApiWithTokenRevoke = createApi({
    reducerPath: 'microServiceApiWithTokenRevoke',
    baseQuery: fetchBaseQuery({
        baseUrl: API_MYSELF,
        extraOptions: { timeout: 30000 },
        prepareHeaders: (headers) => {
            headers.set('content-type', 'application/json')
            headers.set('access-control-allow-origin', '*')
            headers.set('accept', '*/*')
            const tokenRevocationGSE = decryptStorage(localStorage.getItem("tokenRevocationGSE"))
            if (tokenRevocationGSE) headers.set('Authorization', `Bearer ${tokenRevocationGSE}`)
            return headers
        }
    }),
    endpoints: () => ({})
});